import React, {useState} from 'react';

import {sanitizeComment} from 'src/modules/comments/utils/sanitizeComment';

import {Button, FlatButton} from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group, Item} from '@pb/kit-component-group';
import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Loading, Types} from '@pb/kit-component-loading';
import {Tooltip} from '@pb/kit-component-popups';

import {enhanceCommentsBlockMessages} from './enhance-comments.module.styl';

type Props = {
    enhancedComment: string,
    disabled: boolean,
    onEnhancing: boolean,
    onEnhanceClick: () => void,
    setEnhancedComment: (comment: string) => void,
    onChange: (comment: string) => void,
};

const ENHANCE_COMMENT_PLACEHOLDER = 'Click the button below to enhance the comment using AI.';

export const EnhanceCommentView = (props: Props) => {
    const {
        enhancedComment,
        onEnhancing,
        disabled,
        onEnhanceClick,
        setEnhancedComment,
        onChange,
    } = props;

    const [shown, setShown] = useState(false);

    const onClick = () => setShown(true);

    const onClose = () => {
        setShown(false);
        setEnhancedComment('');
    };

    const onApply = () => {
        setShown(false);
        onChange(enhancedComment);
        setEnhancedComment('');
    };

    return (
        <Dialog
            shown={shown}
            anchor={() => (
                <Tooltip
                    anchor={({anchorRef}) => (
                        <BasicIconButton
                            disabled={disabled}
                            ref={anchorRef}
                            iconProps={{type: Icons.SPARKLES, size: Sizes.Size_16}}
                            onClick={onClick}
                        />
                    )}>
                    Enhance Comment
                </Tooltip>
            )}>
            <Group direction="v" justify="space-between" className="pb-m" style={{minWidth: 600, maxWidth: 600}}>
                <DialogHeader onClose={onClose}>AI Assistant</DialogHeader>
                <DialogMain style={{width: '100%'}}>
                    <Group direction="v" gap="m" className="pdx-xl" style={{minHeight: 200, maxHeight: 200}}>
                        <Group>
                            <Item><strong>Enhanced Comment:</strong></Item>
                            {onEnhancing ? (
                                <Loading fast={true} type={Types.ICON}/>
                            ) : null}
                        </Group>
                        {enhancedComment ? (
                            <Group justify="space-between">
                                <Item
                                    style={{width: '100%'}}
                                    className={`${enhanceCommentsBlockMessages} pdx-s`}
                                    dangerouslySetInnerHTML={{
                                        __html: sanitizeComment(enhancedComment),
                                    }}
                                />
                            </Group>
                        ) : (
                            <Item>{ENHANCE_COMMENT_PLACEHOLDER}</Item>
                        )}
                    </Group>
                    <Group justify="end" className="pdx-xl">
                        <FlatButton disabled={!enhancedComment || onEnhancing} onClick={onApply}>Apply</FlatButton>
                    </Group>
                </DialogMain>
                <DialogFooter>
                    <Button style={{width: '100%'}} variant="Type.SECONDARY" onClick={onEnhanceClick}>
                        Enhance Comment
                    </Button>
                </DialogFooter>
            </Group>
        </Dialog>
    );
};
